<template>
  <div class="step clearfix">
    <div class="box fl" v-for="i in stepList" :key="i.code">
      <div @click="changTab(i)" :class="comClass(i)" class="step-btn">
        {{ i.name }}
      </div>
    </div>
    <div class="box2 fl">
      <el-button
        v-if="activeTab == 'link' || activeTab == 'extraTranining'"
        type="primary"
        size="small"
        class="fr"
        @click="$emit('submit')"
        >发布</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activeTab: '',
    isChangeTab: '',
    moduleType: '' //eduResearch 教研活动 	train 培训  topicResearch 项目课题研究  extraTraining 校外培训
  },
  data() {
    return {
      stepList: ''
    }
  },
  created() {
    if (this.moduleType == 'eduResearch') {
      this.stepList = [
        {
          code: 'eduForm',
          name: '创建活动'
        },
        {
          code: 'link',
          name: '活动环节'
        }
      ]
    } else if (this.moduleType == 'train') {
      this.stepList = [
        {
          code: 'eduForm',
          name: '创建培训'
        },
        {
          code: 'link',
          name: '培训环节'
        }
      ]
    } else if (this.moduleType == 'extraTraining') {
      this.stepList = [
        {
          code: 'extraTranining',
          name: '创建校外培训'
        }
      ]
    }
  },
  methods: {
    comClass(i) {
      if (this.activeTab == i.code) {
        return 'active'
      }
      if (!this.isChangeTab) {
        return 'disabled'
      }
    },
    changTab(i) {
      this.isChangeTab && this.$emit('changTab', i.code)
    }
  }
}
</script>

<style lang="less" scoped>
.step {
  background-color: #fff;
  padding: 2px;
  .box:nth-of-type(1) {
    text-align: right;
    width: 30%;
  }
  .box:nth-of-type(2) {
    text-align: left;
    width: 30%;
    margin-left: 20%;
  }
  .box2 {
    padding-top: 3px;
    width: 15%;
  }
  .step-btn {
    cursor: pointer;
    display: inline-block;
    padding: 8px 20px;
    color: #000;
    font-size: 14px;
    font-weight: 700;
  }
  .step-btn:hover {
    border-bottom: 2px solid @color;
    color: @color;
  }
  .active {
    border-bottom: 2px solid @color;
    color: @color;
  }
  .disabled {
    cursor: no-drop !important;
    color: @hui !important;
    border-bottom: 0.1px solid #fff !important;
  }
}
</style>
